if (document.querySelector('.download-image')) {
    document.querySelector('.select-wrapper select').addEventListener('click', function() {
        this.querySelector('select').click();
    });
}